module.exports = __webpack_public_path__ + "img/title_sp.b84e9eef.svg";